import React from 'react';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import WarningIcon from '@mui/icons-material/Warning';
import CancelIcon from '@mui/icons-material/Cancel';
import type { HealthStatus } from '../../types/dataHealth.types';

interface HealthStatusBadgeProps {
  status: HealthStatus;
  size?: 'small' | 'medium';
  showIcon?: boolean;
  showLabel?: boolean;
}

const statusConfig: Record<HealthStatus, {
  color: 'success' | 'warning' | 'error' | 'default';
  icon: React.ElementType;
  label: string;
}> = {
  HEALTHY: {
    color: 'success',
    icon: CheckCircleIcon,
    label: 'Healthy'
  },
  LAGGING: {
    color: 'warning',
    icon: AccessTimeIcon,
    label: 'Lagging'
  },
  STALE: {
    color: 'warning',
    icon: WarningIcon,
    label: 'Stale'
  },
  FAILED: {
    color: 'error',
    icon: CancelIcon,
    label: 'Failed'
  }
};

export const HealthStatusBadge: React.FC<HealthStatusBadgeProps> = ({
  status,
  size = 'medium',
  showIcon = true,
  showLabel = true
}) => {
  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <Chip
      label={showLabel ? config.label : ''}
      color={config.color}
      size={size}
      icon={showIcon ? <Icon /> : undefined}
      sx={{
        fontWeight: 500
      }}
    />
  );
};
